// extracted by mini-css-extract-plugin
module.exports = {"basePlan":"DingBeautyBasePlan_basePlan_2rh_x"};